<template>
    <filters-block @toggle="$emit('toggle')" :collapse="collapse" :title="localizeList.timeTitle" :open="open">
        <div class="time-filter">
            <div class="departure-there">
                <p class="standard-text">
                    {{localizeList.departureUpper}}:
                    <span class="blue-bold-text">{{time(departureTime[0])}} – {{time(departureTime[1])}}</span>
                </p>
                <base-slider v-model="departureTime" @change="changeDepartureTime($event)"
                             :size="[0, 1439]"/>
            </div>
            <div class="arrival-back">
                <p class="standard-text">
                    {{localizeList.arrivalUpper}}:
                    <span class="blue-bold-text">{{time(arrivalTime[0])}} – {{time(arrivalTime[1])}}</span>
                </p>
                <base-slider v-model="arrivalTime" @change="changeArrivalTime($event)"
                             :size="[0, 1439]"/>
            </div>
        </div>
    </filters-block>
</template>

<script>
    import FiltersBlock from "./filtersBlock";
    export default {
        name: "time-filter",
        components: {
            FiltersBlock
        },
        props: {
            collapse: {
                type: Number,
                default: 0
            },
            open: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                arrivalTime: this.$parent.$parent.$parent.arrivalTime,
                departureTime: this.$parent.$parent.$parent.departureTime
            }
        },
        methods: {
            changeDepartureTime(e) {
                this.$parent.$parent.filtersLoader = true;
                this.$parent.$parent.$parent.departureTime = [...e];
                this.$parent.$parent.$parent.changeDepartureTime(e)
            },
            changeArrivalTime(e) {
                this.$parent.$parent.filtersLoader = true;
                this.$parent.$parent.$parent.arrivalTime = [...e];
                this.$parent.$parent.$parent.changeArrivalTime(e)
            },
            time(val) {
                let hour = Math.floor(val / 60);
                let minute = Math.round(val % 60);
                return (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute)
            }
        }
    }
</script>

<style scoped>

    .arrival-back .standard-text,
    .departure-there .standard-text {
        font-weight: 400;
        font-size: 15px;
        line-height: 18px;
        color: var(--dark-1-color);
        margin-bottom: 24px;
    }

    .departure-there {
        margin-bottom: 30px;
        width: calc(100% - 20px);
    }

    .arrival-back {
        margin-bottom: 10px;
        width: calc(100% - 20px);
    }

</style>